// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3lzu5","label":"LabeledBox_label__HqspK"};